class AnnouncementController {
    constructor($state, $scope, $stateParams, $sce, AnnouncementAPI, NewAPI, pageTitle) {
        "ngInject";

        $scope.announcement = null;
        $scope.error = false;
        $scope.contentHtml = '';
        this.$state = $state
        var api = AnnouncementAPI;
        if ($state.is('app.page.news')) {
            api = NewAPI
        }

        function init() {
            if (!$stateParams.id) {
                $scope.error = true;
                return;
            }

            api.one($stateParams.id).get().then(
                function (announcement) {
                    $scope.announcement = announcement;
                    pageTitle.setTitle(announcement.title);
                    $scope.contentHtml = $sce.trustAsHtml($scope.announcement.content);
                },
                function () {
                    $scope.error = true;
                }
            );
        }

        init();
    }
}

export default AnnouncementController;



// WEBPACK FOOTER //
// ./src/app/components/page/announcement/announcement.controller.js